<template>
  <div>
    <Banner :banner="banner"/>
    <div class="job">
      <div class="container">
        <el-table ref="table" :data="tableData" @row-click="click" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="top" v-html="props.row.MEMO"></div>
              <div class="bottom">
                <div class="link flex">
                  <a @click="form(props.row.POSITION,true)">推荐人才</a>
                  <a @click="form(props.row.POSITION)">投递简历</a>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="POSITION" label="招聘岗位"></el-table-column>
          <el-table-column prop="ADDRESS" label="工作地点"></el-table-column>
          <el-table-column prop="NUM" label="招聘人数"></el-table-column>
          <el-table-column prop="NOTETIME" label="发布日期"></el-table-column>
        </el-table>
      </div>
    </div>
    <transition  name="fade" mode="out-in">
    <div class="boomtxt" v-show="formShow">
      <div class="boomW">
        <div class="ip_group">
          <form name="form" @submit.prevent="submit" enctype="multipart/form-data">
            <input type="hidden" name="岗位" :value="post" id="post">
            <label class="lab5">
              <span>姓名</span>
              <input class="txt" type="text" name="姓名" v-model="name" required>
            </label>
            <label class="lab5">
              <span>性别</span>
              <select class="txt" name="性别" v-model="sex" style="padding:0 5px; width:24%">
                <option value="男">男</option>
                <option value="女">女</option>
              </select>
              <span style="width:20%">年龄</span>
              <input class="txt" type="text" name="年龄" v-model="age" required style="width:25%">
            </label>
            <label class="lab5">
              <span>学历</span>
              <input class="txt" type="text" name="学历" required v-model="edu">
            </label>
            <label class="lab5">
              <span>工作年限</span>
              <select name="工作年限" class="txt" v-model="year" required style="width:182px;">
                <option value="不限">|--不限</option>
                <option value="1—3年">|--1—3年</option>
                <option value="3—5年">|--3—5年</option>
                <option value="5年以上">|--5年以上</option>
              </select>
            </label>
            <label class="lab5">
              <span>现工作地点</span>
              <input class="txt" type="text" name="现工作地点" required v-model="address">
            </label>
            <label class="lab5 wcnm" v-if="tuijian">
              <span>推荐人</span>
              <input class="txt" type="text" name="推荐人" required v-model="rec">
            </label>
            <label class="lab5 wcnm" v-if="tuijian">
              <span>推荐人联系方式</span>
              <input class="txt" type="text" name="推荐人联系方式" required v-model="rec_mobile">
            </label>
            <label class="lab3">
              <input class="sub" type="submit" name="submit" value="提交简历">
            </label>
          </form>
        </div>
        <div class="close" @click="formShow=false"></div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import { mapState } from 'vuex'
import { getJobUrl } from '@/util/lang.js'
import Scrollbar from 'smooth-scrollbar';
export default {
  components: {
    Banner
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  mounted(){
    Scrollbar.initAll();
  },
  data() {
    return {
      banner: {
        img: "/images/locals/jobbanner.jpg",
        img_loading: "/images/locals_sm/jobbanner.jpg",
        smallimg: "/images/locals/smalljobbanner.jpg",
        smallimg_loading: "/images/locals_sm/smalljobbanner.jpg",
        content: {
          cn: "人力资源",
          en: "JOBS"
        }
      },
      tableData: [],
      formShow: false,
      post: '',
      tuijian: false,
      name: '',
      sex: '男',
      age: '',
      file: '',
      edu: '',
      year: '',
      address: '',
      rec: '',
      rec_mobile: ''
    };
  },
  methods: {
    click(row, event, column) {
      this.$refs.table.toggleRowExpansion(row);
    },
    form(post,tuijian){
      this.formShow=true
      this.post=post
      this.tuijian=tuijian ? true : false;
    },
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    submit(e){
      let formData = new FormData();
      formData.append('post', this.post);
      formData.append('name', this.name);
      formData.append('sex', this.sex);
      formData.append('age', this.age);
      formData.append('edu', this.edu);
      formData.append('year', this.year);
      formData.append('address', this.address);
      formData.append('rec', this.rec);
      formData.append('rec_mobile', this.rec_mobile);
      this.$$axios.post('/php/form.php',formData).then(res => {
        this.$notify({
          title: '成功',
          message: '提交成功',
          type: 'success'
        })
        this.formShow=false
      })
    },
    async fetchData () {
      const url = getJobUrl(this.lang)
      this.$$axios.get(url).then(res => {
        this.tableData = res.data
        this.tableData.map((item)=>{
          item.MEMO=item.MEMO.replace(/\n/g, "<br>")
        })
      })
    }
  },
  created(){
    this.fetchData()
  }
};
</script>

<style scoped>
.job {
  padding: 50px 0;
}
.job .container {
  max-width: 1500px;
  margin: 0 auto;
  background-color: #fafafa;
  padding: 50px;
  text-align: center;
}
.job .container .top {
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 14px;
  color: #666;
  line-height: 26px;
}
.job .container .bottom {
  padding-top: 20px;
  color: #000;
  font-size: 14px;
}
.job .container .bottom .link {
  justify-content: flex-end;
}
.job .container .bottom .link a {
  display: inline-block;
  width: 120px;
  line-height: 38px;
  border: 1px solid #0e6eb8;
  font-size: 14px;
  color: #0e6eb8;
  margin-left: 20px;
  padding-left: 42px;
  transition: 0.3s;
  cursor: pointer;
}
.job .container .bottom .link a:nth-of-type(1) {
  background: url(/images/icon6.png) no-repeat 22px center;
}
.job .container .bottom .link a:nth-of-type(2) {
  background: url(/images/icon7.png) no-repeat 22px center;
}
.job .container .bottom .link a:hover {
  background-color: #0e6eb8;
  color: #fff;
}
.job .container .bottom .link a:nth-of-type(1):hover {
  background-image: url(/images/icon6_h.png);
}
.job .container .bottom .link a:nth-of-type(2):hover {
  background-image: url(/images/icon7_h.png);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}

.boomtxt{position:fixed;left:40%;top:50%;background-color:#f7f7f7;width:570px;height:260px;z-index:1000;margin-top:-130px;margin-left:-160px;border-radius:2px;box-shadow:0px 1px 20px rgba(0,0,0,0.2);font-size: 14px;}
.boomtxt .boomW{padding:40px;}
.boomtxt .boomW label{display:block;position:relative;}
.boomtxt .boomW .lab1 span{display:block;width:110px;height:38px;display:block;background-color:#0e6eb8;border-radius:6px;text-align:center;line-height:38px;color:#fff;cursor:pointer;} 
.boomtxt .boomW label .file{width:110px;height:38px;position:absolute;left:0px;top:0px;opacity:0;cursor:pointer;}
.boomtxt .boomW label .txt{width:80%;height:38px;font-size:14px;color:#666;background-color:#fff;border:1px solid #ddd;box-sizing:border-box;padding:0px 10px;border-radius:0px;outline:none;}
.boomtxt .boomW .lab2{margin:30px 0px;}
.boomtxt .boomW .lab3 .sub{display:block;width:110px;height:38px;display:block;background-color:#0e6eb8;border-radius:6px;text-align:center;line-height:38px;color:#fff;cursor:pointer;border:none;outline:none;} 
.boomtxt .boomW .close{width:21px;height:21px;position:absolute;right:20px;top:20px;background:url(/images/jjclose.gif);border-radius:100%;cursor:pointer;}

.boomtxt {top:30%; height:auto;}
.boomtxt .boomW .lab1{margin-top:20px;}
.boomtxt .boomW .lab1 span { margin:0 auto;}
.boomtxt .boomW .lab2{margin:20px auto; font-size:12px; color:#888;}
.boomtxt .boomW .lab3 .sub{font-size:14px; margin:0 auto;}
.boomtxt .boomW .lab5{width:90%;height:38px;margin:0 0 5px 0;}
.boomtxt .boomW .lab5 span{width:23%;height:32px;display:block;float:left;line-height:32px; text-align:right; margin-right:3%;}    
.boomtxt .boomW .lab5 .txt{width:73%;height:32px;float:left;font-size:14px;color:#666;background-color:#fff;border:1px solid #ddd;box-sizing:border-box;padding:0px 10px;border-radius:0px;outline:none;}

@media (max-width: 768px){
  .job .container{
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
<style>
.el-table,
.el-table__expanded-cell {
  background-color: transparent;
}
.el-table th,
.el-table tr {
  background-color: transparent;
}
.el-table tr.el-table__row td,
.el-table th {
  text-align: center;
}
.el-table tr.el-table__row {
  cursor: pointer;
}
.el-table--enable-row-hover .el-table__body tr.el-table__row:hover > td {
  background-color: #005598;
  color: #fff;
}
.el-table__expand-icon {
  color: inherit;
}
</style>



